import { css } from "@linaria/core";

export const intentPrimary = "#4e56ea";
export const intentNeutral = "#0080ff";
export const intentSuccess = "#20c040";
export const intentPending = "#ffa000";
export const intentWarning = "#ff6000";
export const intentDanger = "#f01830";
export const intentDefault = "#607890";

/** @peprecated - to remove in v5. */
export const intentCritical = "##4e56ea";
export const intentSecondary = "#4e56ea";

export const elGlobals = css`
  :global() {
    @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Source+Code+Pro&display=swap");
    /* Reset CSS */
    html,
    body,
    div,
    span,
    applet,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    a,
    abbr,
    acronym,
    address,
    big,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    s,
    samp,
    small,
    strike,
    strong,
    sub,
    sup,
    tt,
    var,
    b,
    u,
    i,
    center,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    hgroup,
    menu,
    nav,
    output,
    ruby,
    section,
    summary,
    time,
    mark,
    audio,
    video {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      font: inherit;
      vertical-align: baseline;
      line-height: 1.2;
    }
    /* HTML5 display-role reset for older browsers */
    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
      display: block;
    }
    body {
      line-height: 1;
    }
    ol,
    ul {
      list-style: none;
    }
    blockquote,
    q {
      quotes: none;
    }
    blockquote:before,
    blockquote:after,
    q:before,
    q:after {
      content: "";
      content: none;
    }
    table {
      border-collapse: collapse;
      border-spacing: 0;
    }

    /* Some basic defaults */

    html {
      font-size: 16px;
      font-family: "Inter", Helvetica, Arial, sans-serif;
      color: #222b33; // Neutral 900
      height: 100%;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      background: linear-gradient(180deg, #e9f5ff 700%, rgba(229, 239, 255, 0.26) 83.7%, rgba(229, 239, 255, 0) 700%);
      /* background-repeat: no-repeat; */
      background-size: cover;
      /* overflow: hidden; */

      * {
        box-sizing: border-box;
        letter-spacing: -0.01em;
      }
    }

    body {
      height: 100%;
      background: #fff;
      position: relative;
    }

    #root {
      /* height: 100%; */
    }

    a {
      text-decoration: none;
      cursor: pointer;
      color: #4e56ea; // Purple 500
    }

    code,
    pre {
      font-family: "Source Code Pro", monospace;
    }

    strong {
      font-weight: bold;
    }

    :root {
      --neutral-900: #222b33;
      --neutral-800: #323e4b;
      --neutral-700: #415161;
      --neutral-600: #506478;
      --neutral-500: #607890;
      --neutral-400: #798da1;
      --neutral-300: #9faebc;
      --neutral-200: #c5ced6;
      --neutral-150: #d8dee4;
      --neutral-100: #e5e9ed;
      --neutral-050: #f2f4f6;
      --blue-900: #002e5c;
      --blue-800: #004285;
      --blue-700: #0056ad;
      --blue-600: #006bd6;
      --blue-500: #0080ff;
      --blue-400: #2994ff;
      --blue-300: #66b2ff;
      --blue-200: #a3d1ff;
      --blue-100: #d6eaff;
      --blue-050: #ebf5ff;
      --green-900: #0b4517;
      --green-800: #106421;
      --green-700: #15822b;
      --green-600: #1aa135;
      --green-500: #20c040;
      --green-400: #43ca5e;
      --green-300: #79d98c;
      --green-200: #aee8ba;
      --green-100: #dbf4e0;
      --green-050: #edfaf0;
      --yellow-900: #5c3900;
      --yellow-800: #855300;
      --yellow-700: #ad6c00;
      --yellow-600: #d68600;
      --yellow-500: #ffa000;
      --yellow-400: #ffaf29;
      --yellow-300: #ffc666;
      --yellow-200: #ffdca3;
      --yellow-100: #ffefd6;
      --yellow-050: #fff7eb;
      --orange-900: #5c2200;
      --orange-800: #853200;
      --orange-700: #ad4100;
      --orange-600: #d65000;
      --orange-500: #ff6000;
      --orange-400: #ff7929;
      --orange-300: #ff9f66;
      --orange-200: #ffc5a3;
      --orange-100: #ffe5d6;
      --orange-050: #fff2eb;
      --red-900: #560811;
      --red-800: #7d0c19;
      --red-700: #a21020;
      --red-600: #c91428;
      --red-500: #f01830;
      --red-400: #f23d51;
      --red-300: #f67482;
      --red-200: #f9abb4;
      --red-100: #fcd9dd;
      --red-050: #fdecee;
      --purple-900: #262884;
      --purple-800: #3632a6;
      --purple-700: #4036c8;
      --purple-600: #4844da;
      --purple-500: #4e56ea;
      --purple-400: #5573fd;
      --purple-300: #7e9bfa;
      --purple-200: #b0c6fa;
      --purple-100: #d6e1ff;
      --purple-050: #ecf3ff;
      --white: #ffffff;
      --brand-red: #d1263d;
      --brand-teal: #98c1c2;
      --brand-orange: #fd9e1d;
      --brand-black: #222b33;
      --brand-indigo: #08415c;
      --brand-white: #ffffff;
      --brand-pink: #ffeaee;
      --teal-900: #00505a;
      --teal-800: #00646e;
      --teal-700: #008292;
      --teal-600: #0096aa;
      --teal-500: #00acbe;
      --teal-400: #14c4d0;
      --teal-300: #50d2dc;
      --teal-200: #8ce2ea;
      --teal-100: #bef6fa;
      --teal-050: #e2fafa;
      --plum-900: #5a0a82;
      --plum-800: #6e1296;
      --plum-700: #7e20a2;
      --plum-600: #8c2caa;
      --plum-500: #9a32b4;
      --plum-400: #af50c4;
      --plum-300: #bd78cc;
      --plum-200: #d0a0da;
      --plum-100: #e6d2f0;
      --plum-050: #faf4ff;
      --font-weight-regular: 400;
      --font-weight-medium: 500;
      --font-weight-semibold: 600;
      --font-family: Inter;
      --unit-0: 0rem;
      --unit-px: 0.0625rem;
      --unit-half: 0.125rem;
      --unit-1: 0.25rem;
      --unit-2: 0.5rem;
      --unit-3: 0.75rem;
      --unit-4: 1rem;
      --unit-5: 1.25rem;
      --unit-6: 1.5rem;
      --unit-8: 2rem;
      --unit-10: 2.5rem;
      --unit-12: 3rem;
      --unit-14: 3.5rem;
      --unit-16: 4rem;
      --unit-18: 4.5rem;
      --unit-20: 5rem;
      --unit-7: 1.75rem;
      --unit-9: 2.25rem;
      --unit-11: 2.75rem;
      --unit-24: 6rem;
      --unit-28: 7rem;
      --unit-32: 8rem;
      --unit-36: 9rem;
      --unit-40: 10rem;
      --font-size-3xl: 2rem;
      --font-size-2xl: 1.5rem;
      --font-size-xl: 1.25rem;
      --font-size-lg: 1.125rem;
      --font-size-base: 0.9375rem;
      --font-size-sm: 0.875rem;
      --font-size-xs: 0.8125rem;
      --font-size-2xs: 0.75rem;
      --font-size-3xs: 0.625rem;
      --line-height-3xl: 2.5rem;
      --line-height-2xl: 2rem;
      --line-height-xl: 1.75rem;
      --line-height-lg: 1.5rem;
      --line-height-base: 1.5rem;
      --line-height-sm: 1.25rem;
      --line-height-xs: 1rem;
      --line-height-2xs: 1rem;
      --letter-spacing-3xl: -0.019999999552965164rem;
      --letter-spacing-2xl: -0.014999999664723873rem;
      --letter-spacing-xl: -0.012500000186264515rem;
      --letter-spacing-lg: -0.011250000447034836rem;
      --letter-spacing-base: -0.00937500037252903rem;
      --letter-spacing-sm: -0.008750000037252903rem;
      --letter-spacing-xs: -0.008124999701976776rem;
      --letter-spacing-2xs: -0.007499999832361937rem;
      --text-button_reversed-secondary-label-default: #e5e9ed;
      --text-button_reversed-secondary-label-disabled: #798da1;
      --icon-app_bar-default: #798da1;
      --icon-button_primary-default: #d6e1ff;
      --icon-button_primary-hover: #7e9bfa;
      --icon-checkbox-hover: #4036c8;
      --icon-radio_button-hover: #4036c8;
      --icon-button_danger-default: #fcd9dd;
      --icon-button_danger-hover: #f67482;
      --icon-reversed_button-hover: #607890;
      --icon-reversed_button-disabled: #798da1;
      --icon-split_button-secondary-hover: #415161;
      --fill-button-primary-hover: #4036c8;
      --fill-button-danger-hover: #a21020;
      --fill-reversed_button-secondary-disabled: #415161;
      --fill-switch-hover: #4036c8;
      --outline-text_input-default: #d8dee4;
      --outline-text_input-focus: #0080ff;
      --outline-button-secondary-hover: #9faebc;
      --outline-button_reversed-secondary-default: #415161;
      --outline-input_chip-orange: #ffc5a3;
      --text-primary: #222b33;
      --text-secondary: #607890;
      --text-tertiary: #415161;
      --text-placeholder: #9faebc;
      --text-action: #4e56ea;
      --text-error: #f01830;
      --text-success: #1aa135;
      --text-warning: #ff6000;
      --text-info: #0080ff;
      --text-white: #ffffff;
      --text-pending: #d68600;
      --text-accent_1: #0096aa;
      --text-accent_2: #9a32b4;
      --icon-secondary: #607890;
      --icon-primary: #9faebc;
      --icon-disabled: #e5e9ed;
      --icon-action: #4e56ea;
      --icon-error: #f01830;
      --icon-success: #1aa135;
      --icon-warning: #ff6000;
      --icon-info: #0080ff;
      --icon-white: #ffffff;
      --icon-star: #ffa000;
      --icon-pending: #d68600;
      --icon-accent_1: #0096aa;
      --icon-accent_2: #9a32b4;
      --outline-dashed: #d8dee4;
      --outline-default: #e5e9ed;
      --outline-primary: #4e56ea;
      --outline-warning: #ff6000;
      --outline-error: #f01830;
      --outline-info: #0080ff;
      --outline-success: #20c040;
      --outline-white: #ffffff;
      --outline-pending: #d68600;
      --outline-accent_1: #0096aa;
      --outline-accent_2: #9a32b4;
      --fill-default-lightest: #f2f4f6;
      --fill-default-light: #e5e9ed;
      --fill-default-medium: #9faebc;
      --fill-default-dark: #607890;
      --fill-default-darkest: #222b33;
      --fill-action-lightest: #ecf3ff;
      --fill-action-light: #d6e1ff;
      --fill-action-dark: #4e56ea;
      --fill-success-lightest: #edfaf0;
      --fill-success-dark: #20c040;
      --fill-warning-lightest: #fff2eb;
      --fill-warning-dark: #ff6000;
      --fill-error-lightest: #fdecee;
      --fill-error-light: #fcd9dd;
      --fill-error-dark: #f01830;
      --fill-white: #ffffff;
      --fill-info-lightest: #ebf5ff;
      --fill-info-dark: #0080ff;
      --fill-pending-lightest: #fff7eb;
      --fill-accent_1-lightest: #e2fafa;
      --fill-accent_2-lightest: #faf4ff;
      --fill-warning-light: #ffe5d6;
      --fill-success-light: #dbf4e0;
      --fill-info-light: #d6eaff;
      --fill-pending-light: #ffefd6;
      --fill-pending-dark: #d68600;
      --fill-accent_1-light: #bef6fa;
      --fill-accent_1-dark: #0096aa;
      --fill-accent_2-light: #e6d2f0;
      --fill-accent_2-dark: #9a32b4;
      --spacing-none: 0rem;
      --spacing-half: 0.125rem;
      --spacing-1: 0.25rem;
      --spacing-2: 0.5rem;
      --spacing-3: 0.75rem;
      --spacing-4: 1rem;
      --spacing-5: 1.25rem;
      --spacing-6: 1.5rem;
      --spacing-7: 2rem;
      --spacing-8: 2.5rem;
      --spacing-9: 3rem;
      --spacing-10: 3.5rem;
      --spacing-11: 4rem;
      --spacing-12: 4.5rem;
      --spacing-13: 5rem;
      --spacing-14: 6rem;
      --spacing-15: 7rem;
      --spacing-16: 8rem;
      --spacing-17: 9rem;
      --spacing-18: 10rem;
      --corner-none: 0rem;
      --corner-sm: 0.125rem;
      --corner-default: 0.25rem;
      --corner-xl: 0.75rem;
      --corner-2xl: 1rem;
      --corner-3xl: 1.5rem;
      --corner-lg: 0.5rem;
      --border-none: 0rem;
      --border-default: 0.0625rem;
      --border-double: 0.125rem;
      --size-none: 0rem;
      --size-half: 0.125rem;
      --size-1: 0.25rem;
      --size-2: 0.5rem;
      --size-3: 0.75rem;
      --size-4: 1rem;
      --size-5: 1.25rem;
      --size-6: 1.5rem;
      --size-7: 1.75rem;
      --size-8: 2rem;
      --size-9: 2.25rem;
      --size-10: 2.5rem;
      --size-11: 2.75rem;
      --size-12: 3rem;
      --size-14: 3.5rem;
      --size-16: 4rem;
      --size-18: 4.5rem;
      --size-20: 5rem;
      --size-24: 6rem;
      --size-28: 7rem;
      --size-32: 8rem;
      --size-36: 9rem;
      --size-40: 10rem;
      --size-px: 0.0625rem;
      --icon-xs: 0.75rem;
      --icon-sm: 1rem;
      --icon-md: 1.25rem;
      --icon-default: 1.5rem;

      --white: #fff;
      --black: var(--neutral-900);
      --neutral-darkest: var(--neutral-700);
      --neutral-dark: var(--neutral-500);
      --neutral-medium: var(--neutral-400);
      --neutral-medium-light: var(--neutral-300);
      --neutral-light: var(--neutral-100);
      --neutral-lightest: var(--neutral-050);

      /** intent color variables */
      --intent-primary: var(--purple-500);
      --intent-neutral: var(--blue-500);
      --intent-success: var(--green-500);
      --intent-pending: var(--yellow-500);
      --intent-warning: var(--orange-500);
      --intent-danger: var(--red-500);
      --intent-default: var(--neutral-500);

      /* intent light colors */
      --intent-primary-light: var(--purple-300);
      --intent-neutral-light: var(--blue-300);
      --intent-success-light: var(--green-300);
      --intent-pending-light: var(--yellow-300);
      --intent-warning-light: var(--orange-300);
      --intent-danger-light: var(--red-300);
      --intent-default-light: var(--neutral-300);

      /* intent lightest colors */
      --intent-primary-lightest: var(--purple-050);
      --intent-neutral-lightest: var(--blue-050);
      --intent-success-lightest: var(--green-050);
      --intent-pending-lightest: var(--yellow-050);
      --intent-warning-lightest: var(--orange-050);
      --intent-danger-lightest: var(--red-050);
      --intent-default-lightest: var(--neutral-050);

      /** intent dark colors */
      --intent-primary-dark: var(--purple-700);
      --intent-neutral-dark: var(--blue-700);
      --intent-success-dark: var(--green-700);
      --intent-pending-dark: var(--yellow-700);
      --intent-warning-dark: var(--orange-700);
      --intent-danger-dark: var(--red-700);
      --intent-default-dark: var(--neutral-700);

      /** font variables */
      --font-sans-serif: "Inter", Helvetica, Arial, sans-serif;
      --font-monospace: "Source Code Pro", monospace;

      /** font size variables */
      --font-size-heading: 1.5rem;
      --font-size-subheading: 1.25rem;
      --font-size-small-subheading: 1.125rem;
      --font-size-default: 0.9375rem;
      --font-size-small: 0.875rem;
      --font-size-smallest: 0.8125rem;
      --font-weight-default: 400;
      --font-weight-medium: 500;
      --font-weight-bold: 600;

      /** layout size */
      --layout-size-base: 1rem;
      --layout-size-molecule: 1.25rem;
      --layout-size-atom: 0.75rem;

      /** other defaults */
      --default-border-radius: 0.25rem;

      /** component specific variables */
      --component-input-bg: var(--white);
      --component-input-focus-bg: var(--neutral-light);
      --component-input-shadow: inset 0px -1px 0px var(--white);
      --component-input-border: 1px solid var(--neutral-150);
      --component-input-border-focus: 1px solid var(--purple-500);
      --component-steps-gutter-width: 12px;
      --component-table-min-column-width: 3rem;

      /** Navigation specific variables */
      --nav-menu-background-dark: var(--white);
      --nav-menu-background-accent: var(--white);
      --nav-menu-text: var(--neutral-medium);
      --nav-menu-text-hover: var(--neutral-dark);
      --nav-menu-icon-primary-accent: var(--neutral-600);
      --nav-menu-icon-secondary-accent: var(--neutral-400);
      --nav-brand-height: 1.5rem;

      /* Component specific variables */
      --page-header-bg: var(--white);
      --page-header-border: 1px solid var(--neutral-100);
      --pagination-bg: var(--white);

      --blue-light: var(--purple-300);
      --blue-light2: var(--purple-300);
      --blue-dark: var(--purple-700);
      --blue-dark2: var(--purple-700);
      --intent-low: var(--neutral-light);
      --intent-secondary: var(--purple-500);
      --intent-secondary-light: var(--purple-300);
      --intent-secondary-dark: var(--purple-700);
      --intent-critical: var(--purple-500);
      --intent-critical-text: var(--white);
      --intent-critical-light: var(--purple-300);
      --intent-critical-light-text: var(--black);
      --intent-critical-dark: var(--purple-700);
      --intent-critical-dark-text: var(--white);

      --content-width: min(100%, 1140px);

      --theme-hover-color: #7fb4de;
      --theme-main-secondary-color: #437cbb;

      --theme-main-color: #7fb4de;
      --theme-main-green-color: #8ac055;
      --theme-main-dark-color: #10575c;
      --theme-main-flat-dark-color: #000;
      --theme-main-flat-color: #fff;
    }
  }
`;
